import React from 'react';
import { Spinner } from '../../design-system';

type LoadingStateVariant = 'default' | 'section' | 'page' | 'inline' | 'panel';

interface AccountSettingsLoadingStateProps {
  className?: string;
  label: string;
  text: string;
  variant?: LoadingStateVariant;
}

const AccountSettingsLoadingState = ({
  className = '',
  label,
  text,
  variant = 'default',
}: AccountSettingsLoadingStateProps): React.ReactElement => {
  const variantClass = variant === 'default' ? '' : ` account-settings-loading-state--${variant}`;
  const classNames = `account-settings-loading-state${variantClass}${className ? ` ${className}` : ''}`;

  return (
    <div className={classNames}>
      <Spinner label={label} />
      <span>{text}</span>
    </div>
  );
};

export default AccountSettingsLoadingState;
